<template>
  <v-container fluid>
    <PageHeader no-padding />

    <v-card>
      <Subheader v-model="search" title="Depth / Height Datums" search="data">
        <v-btn dark color="success" @click="showAddDatumDialog=!showAddDatumDialog">
          <v-icon>add</v-icon>
          {{ $t('Button.AddDatum') }}
        </v-btn>
      </Subheader>
      <v-card-text>
        <v-data-table :headers="headers" :items="datumList" :pagination.sync="pagination" :search="search">
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{ props.item.DatumType.Name }}</td>
            <td class="text-xs-left">{{ props.item.DatumName }}</td>
            <td class="text-xs-left">{{ props.item.DatumDescription }}</td>
            <v-btn color="primary" @click="datumDetail = props.item; showEditDatumDialog = !showEditDatumDialog">
              <v-icon class="mr-1">edit</v-icon>{{ $t('Button.EditDatum') }}
            </v-btn>
            <v-btn color="error" @click="dialog = true; deleteDatumName = props.item.DatumName; getDeleteDatumDetails()">
              <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.DeleteDatum') }}
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="500">
      <v-card v-if="!isLoading">
        <v-toolbar dark color="primary">
          <v-toolbar-title>Delete Datum</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="headline">{{ datumDeleteText }} </v-card-title>
        <v-card-text v-for="(numMeasurements, station) in deleteDatumDetails" :key="station" style="padding-bottom: 0px; padding-top: 0px;">
          <p> <span style="font-weight: bold;">{{station}}</span> containing {{numMeasurements}} measurements</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="agreeDeleteDatum()" :disabled="deleteButtonDisabled">
            <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.DeleteDatum') }}
          </v-btn>
          <v-btn color="secondary" outline @click="dialog = false">{{ $t('Button.Cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else>
        <div class="text-xs-center">
          <v-progress-circular :indeterminate='true'></v-progress-circular>
        </div>
      </v-card>
    </v-dialog>

    <AdministrationAddDatumDialog :show="showAddDatumDialog" :datumList.sync="datumList" :name="tenantName" @refreshDatumList="populateDatumList" />

    <AdministrationEditDatumDialog :show="showEditDatumDialog" :datumList.sync="datumList" :datumDetail="datumDetail" :name="tenantName" @refreshDatumList="populateDatumList" />

  </v-container>
</template>

<script>

  import {
    createNamespacedHelpers,
  } from 'vuex'

  import AdministrationAddDatumDialog from './AdministrationAddDatumDialog.vue'
  import AdministrationEditDatumDialog from './AdministrationEditDatumDialog.vue'

  const uiConfig = createNamespacedHelpers('uiconfig')
  const datum = createNamespacedHelpers('datum')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      AdministrationAddDatumDialog,
      AdministrationEditDatumDialog,
    },
    props: {
      name: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        dialog: false,
        search: '',
        pagination: {
          sortBy: '',
        },
        complexObject: {
          complex: 'asd',
          objecto: 'def',
        },
        headers: [{
          align: 'left',
          text: 'Datum Type',
          value: 'DatumType',
        },
        {
          align: 'left',
          text: 'Datum',
          value: 'DatumValue',
        },
        {
          align: 'left',
          text: 'Description',
          value: 'DatumDescription',
        },
        {
          sortable: false,
          text: '',
          value: '',
        },
        ],
        showAddDatumDialog: false,
        showEditDatumDialog: false,
        datumDetail: {},
        isLoading: false,
        deleteDatumName: '',
        datumDeleteText: '',
        deleteDatumDetails: {},
      }
    },
    computed: {
      ...uiConfig.mapGetters(['uiConfigOptions']),
      ...datum.mapGetters(['datumList']),
      ...authenticate.mapGetters(['currentTenant']),
      deleteButtonDisabled() {
        return Object.keys(this.deleteDatumDetails).length > 0
      },
      tenantName() {
        return this.name || this.currentTenant && this.currentTenant.name
      },
    },
    mounted() {
      if (!this.datumList || this.datumList.length == 0) {
        this.populateDatumList()
      }
    },
    methods: {
      ...datum.mapActions([
        'getDatumListForTenant',
        'deleteDatum',
        'getDatumDetails',
      ]),
      populateDatumList() {
        let options = {
          successCb: () => {},
          tenantName: this.tenantName,
        }
        this.getDatumListForTenant(options)
      },
      agreeDeleteDatum() {
        var foundDatum = this.datumList.filter(x => x.DatumName === this.deleteDatumName)[0]
        let options = {
          tenantName: this.tenantName,
          data: foundDatum,
          successCb: () => {
            this.populateDatumList()
            this.$store.dispatch('app/setSnackbar', {
              text: 'Delete successful',
              color: 'success',
              icon: 'done',
            })

            this.dialog = false
          },
          failedCb: (err) => {
            this.$store.dispatch('app/setSnackbar', {
              text: err,
              color: 'error',
              icon: 'error',
            })
          },
        }
        this.deleteDatum(options)
      },
      getDeleteDatumDetails() {
        this.isLoading = true
        this.deleteDatumDetails = {}
        let foundDatum = this.datumList.find(x => x.DatumName === this.deleteDatumName)
        if (foundDatum) {
          let options = {
            tenantName: this.tenantName,
            data: foundDatum,
            successCb: (data) => {
              this.deleteDatumDetails = {}
              if (data && !data.IsDatumUsed) {
                this.datumDeleteText =
                  `The datum '${this.deleteDatumName}' is not used anywhere and is safe to delete. Are you sure you want to delete this?`
              } else if (data && data.IsDatumUsed && data.DatumStationDetails && data.DatumStationDetails.length >
                0) {
                this.datumDeleteText =
                  `The datum '${this.deleteDatumName}' can not be deleted as it is being used by the following stations: `
                for (let i = 0; i < data.DatumStationDetails.length; i++) {
                  this.deleteDatumDetails[data.DatumStationDetails[i].StationName] = data.DatumStationDetails[i]
                    .NumMeasurementsUsingDatum
                }
              }
              this.isLoading = false
            },
          }
          this.getDatumDetails(options)
        }
      },
    },
  }
</script>

<style scoped lang="stylus"></style>